import { useEffect, useState } from "react";

import searchIcon from "../../assets/drawables/search.svg";
import england from "../../assets/drawables/england.svg";
import nigeria from "../../assets/drawables/nigeria.svg";
import angola from "../../assets/drawables/angola.svg";
import EachLocation from "./EachLocation";
import down from "../../assets/drawables/down.svg";
const ConvertFlagDropDown = ({ defaultCurrency, handleCurrency }) => {
  // const [selected, setSelected] = useState({ img: "", code: "", country: "" });
  const [show, setShow] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  // const handleShow = () => {
  //   setShow(!show);
  // };
  const [location, setLocation] = useState({
    img: nigeria,
    code: "+234",
    country: "Nigeria",
  });

  const [answer, setAnswer] = useState({
    img: england,
    code: "+234",
    country: "Usa",
  });

  useEffect(() => {
    handleCurrency(answer.code);
  }, [answer]);

  const handleAnswer = ({ img, code, country }) => {
    setSearchValue("");
    setAnswer({
      img,
      code,
      country,
    });
  };
  const countryList = [
    { img: nigeria, code: "+234", country: "Nigeria" },
    { img: england, code: "+61", country: "England" },
    { img: angola, code: "+1", country: "Angola" },
    { img: nigeria, code: "+234", country: "Nigeria" },
    { img: england, code: "+61", country: "England" },
    { img: angola, code: "+1", country: "Angola" },
    { img: nigeria, code: "+234", country: "Nigeria" },
    { img: england, code: "+61", country: "England" },
    { img: angola, code: "+1", country: "Angola" },
    { img: angola, code: "+1", country: "Angola" },
    { img: nigeria, code: "+234", country: "Nigeria" },
    { img: england, code: "+61", country: "England" },
    { img: angola, code: "+1", country: "Angola" },
    { img: angola, code: "+1", country: "Angola" },
    { img: nigeria, code: "+234", country: "Nigeria" },
    { img: england, code: "+61", country: "England" },
    { img: angola, code: "+1", country: "Angola" },
    { img: angola, code: "+1", country: "Angola" },
    { img: nigeria, code: "+234", country: "Nigeria" },
    { img: england, code: "+61", country: "England" },
    { img: angola, code: "+1", country: "Angola" },
  ];
  const [searchResult, setSearchResult] = useState(countryList);

  useEffect(() => {
    if (searchValue) {
      const newList = [...countryList].filter((item) => {
        return item.country
          .toLocaleLowerCase()
          .includes(searchValue.toLocaleLowerCase());
      });

      setSearchResult(newList);
    } else {
      setSearchResult(countryList);
    }
  }, [searchValue]);

  return (
    <div className="pd_convert_flag_drop_down">
      <div
        onClick={() => {
          if (show) {
            setShow(false);
          } else {
            setShow(true);
          }
        }}
        className="showCurrency"
      >
        <img className="smallFlag" src={answer.img} alt="" />
        <p className="name">{answer.code}</p>
        <img src={down} alt="down" />
      </div>

      <div className={`drop_down ${show ? "show" : ""}`}>
        <div className="drop_box">
          <img src={searchIcon} alt="search" className="search" />
          <input
            onClick={() => {
              setShow(true);
            }}
            name="country"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            placeholder="Search for currency"
            type="text"
          />
        </div>
        <div className="overflow">
          <div className="own_country">
            <p className="title">POPULAR CURRENCIES</p>

            <EachLocation
              onClick={() => {
                handleAnswer(location);
                setShow(false);
              }}
              item={location}
            />
            <EachLocation
              onClick={() => {
                handleAnswer(location);
                setShow(false);
              }}
              item={location}
            />
            <EachLocation
              onClick={() => {
                handleAnswer(location);
                setShow(false);
              }}
              item={location}
            />
          </div>
          <div className="all_country">
            <p className="title">ALL CURRENCIES</p>
            <div className="location_list">
              {!searchResult.length ? (
                <p className="empty">Empty Search</p>
              ) : (
                searchResult.map((item) => {
                  return (
                    <EachLocation
                      onClick={() => {
                        handleAnswer(item);
                        setShow(false);
                      }}
                      item={item}
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvertFlagDropDown;
